import { Box, Grid, Stack } from '@mui/material';

import { ReactElement, useCallback, useLayoutEffect, useState } from 'react';
import {
    AppFormikTextArea,
    AppFormikTextField,
    ButtonComp,
} from 'shared/components/AppComponents';
// import { SwitchComp } from 'shared/components/Switch';
import TypographyLevel from 'shared/components/Typography';
import DateFnsAdapter from '@date-io/date-fns';

import { SwitchComp } from 'shared/components/Switch';
// import { ClientService } from 'services';
import { ChecklistStep } from '../Main';
import { ClientService } from 'services';
import { Utils } from 'shared/helpers';

const dateFns = new DateFnsAdapter();

/**
 * CheckListClientSettings component.
 *
 * @param {CheckListClientSettingsProps} props - The component props.
 * @returns {ReactElement} The rendered component.
 */
const CheckListClientSettings: React.FC<CheckListClientSettings> = ({
    clientId,
    statusPage,
    handleClick,
    statusReplace,
    placeholder,
    checkListHistory,
    updatedAt,
    setStatusReplace,
    setFilename,
    InputcheckList,
    ChecklistStepData,
    isReplaceable,
}): ReactElement => {
    const [savedChecklistStepData, setSavedChecklistStepData] = useState<
        ChecklistStep[]
    >([]);
    const [isLookHistory, setStatusLookHistory] = useState<boolean>(false);

    useLayoutEffect(() => {
        setSavedChecklistStepData(ChecklistStepData);
    }, [ChecklistStepData]);

    /**
     * checklist handle switch to toggle with the api
     * @param {boolean} toggle - The boolean from changed switch.
     */
    const actionToSwitchBetweenHandledChecklistStep = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            const container = event.target.parentElement;
            if (container) {
                const stepId = container.getAttribute('data-stepId');
                if (stepId !== null) {
                    ClientService.toggleClientChecklist({
                        clientId,
                        stepId,
                    })
                        .then((response) => {
                            Utils.handleSuccessResponse(response);
                            setSavedChecklistStepData((prevState) =>
                                Array.from(prevState).map((element) => {
                                    if (element.actions.uuid === stepId) {
                                        return {
                                            ...element,
                                            enabled: checked,
                                        };
                                    }
                                    return {
                                        ...element,
                                    };
                                })
                            );
                        })
                        .catch((error) => {
                            setSavedChecklistStepData((prevState) =>
                                Array.from(prevState).map((element) => {
                                    if (element.actions.uuid === stepId) {
                                        return {
                                            ...element,
                                            enabled: !checked,
                                        };
                                    }
                                    return {
                                        ...element,
                                    };
                                })
                            );
                            Utils.handleErrorResponse(error);
                        });
                }
            }
        },
        [clientId]
    );
    /**
     * checklist handle switch to toggle with the api
     * @param {boolean} toggle - The boolean from changed switch.
     */
    const actionToSwitchBetweenReviewStepActivation = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            const container = event.target.parentElement;
            if (container) {
                const stepId = container.getAttribute('data-stepId');
                if (stepId !== null) {
                    ClientService.toggleHideCheck({
                        clientId,
                        stepId,
                    })
                        .then((response) => {
                            Utils.handleSuccessResponse(response);
                            setSavedChecklistStepData((prevState) =>
                                Array.from(prevState).map((element) => {
                                    if (element.actions.uuid === stepId) {
                                        return {
                                            ...element,
                                            hideStep: checked,
                                        };
                                    }
                                    return {
                                        ...element,
                                    };
                                })
                            );
                        })
                        .catch((error) => {
                            setSavedChecklistStepData((prevState) =>
                                Array.from(prevState).map((element) => {
                                    if (element.actions.uuid === stepId) {
                                        return {
                                            ...element,
                                            hideStep: !checked,
                                        };
                                    }
                                    return {
                                        ...element,
                                    };
                                })
                            );
                            Utils.handleErrorResponse(error);
                        });
                }
            }
        },
        [clientId]
    );
    return (
        <Box className="client-checklist">
            {/* Checklist file */}
            {statusPage !== 'edit' ? (
                <Box>
                    <Box className="container-add-checklist">
                        <Box className="header-add-checklist">
                            <TypographyLevel variant="four">
                                Checklist file
                            </TypographyLevel>
                        </Box>

                        <Box className="content-input-add-checklist">
                            <AppFormikTextArea
                                name="checklist"
                                className="checklist-new-client"
                                placeholder="Select the file to upload"
                                readOnly
                                endAdornment={
                                    <ButtonComp
                                        className="upload-checklist"
                                        onClick={handleClick}
                                        type="neutral"
                                    >
                                        Upload
                                    </ButtonComp>
                                }
                            />
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box className="container-checklist" mt={8}>
                    <Box
                        className="header-replace-checklist"
                        role="tablist"
                        aria-labelledby="heading-checklist heading-content-checklist"
                    >
                        <Box>
                            <TypographyLevel
                                variant="three"
                                className="headerTitle"
                                id="heading-checklist"
                            >
                                Checklist
                            </TypographyLevel>
                            <TypographyLevel
                                variant="four"
                                className="header-updated-at"
                                id="heading-content-checklist"
                            >
                                {`Current: ${placeholder} (uploaded at ${dateFns.format(
                                    updatedAt,
                                    'normalDate'
                                )} ${dateFns.format(updatedAt, 'year')})`}
                            </TypographyLevel>
                        </Box>
                        <Box>
                            <Box className="button-group-checklist">
                                <ButtonComp
                                    type="neutral"
                                    className="history-checklist-button"
                                    width="9.5rem"
                                    onClick={() => {
                                        setStatusLookHistory(!isLookHistory);
                                        setStatusReplace(false);
                                    }}
                                    role="tab"
                                    id={
                                        !isLookHistory && !statusReplace
                                            ? 'tab-item-settings-checklist'
                                            : 'tab-item-checklist'
                                    }
                                    aria-controls={
                                        !isLookHistory && !statusReplace
                                            ? 'item-settings-checklist'
                                            : 'item-checklist'
                                    }
                                >
                                    {isLookHistory
                                        ? 'Close history'
                                        : 'Checklist history'}
                                </ButtonComp>
                                <ButtonComp
                                    type="neutral"
                                    width="9.5rem"
                                    className="replace-checklist-button"
                                    disabled={
                                        statusReplace || isReplaceable === false
                                    }
                                    onClick={() => {
                                        setStatusLookHistory(false);
                                        setStatusReplace(true);
                                    }}
                                    role="tab"
                                    id="tab-replace-checklist"
                                    aria-controls="replace-checklist"
                                >
                                    Replace checklist
                                </ButtonComp>
                            </Box>
                        </Box>
                    </Box>

                    <Box
                        className="container-replace-checklist"
                        role="tabpanel"
                        id="replace-checklist"
                        aria-labelledby="tab-replace-checklist"
                    >
                        {statusReplace && !isLookHistory && (
                            <>
                                <Box className="checklist-replacement-name">
                                    <TypographyLevel
                                        variant="four"
                                        className="checklist-label-name"
                                    >
                                        Checklist name
                                    </TypographyLevel>
                                    <AppFormikTextField
                                        name="checklistName"
                                        placeholder="Type here"
                                        onChange={(event: any) =>
                                            setFilename(event.target.value)
                                        }
                                    />
                                </Box>
                                <Box className="checklist-replacement-file">
                                    <TypographyLevel
                                        variant="four"
                                        className="checklist-label-file"
                                    >
                                        Checklist file
                                    </TypographyLevel>

                                    <AppFormikTextArea
                                        name="checklist"
                                        placeholder="Select the file to upload"
                                        disabled
                                        readOnly
                                        endAdornment={
                                            <ButtonComp
                                                type="secondary"
                                                className="ButtonEndAdornment"
                                                onClick={handleClick}
                                            >
                                                {InputcheckList.filename
                                                    ? 'Change'
                                                    : 'Upload'}
                                            </ButtonComp>
                                        }
                                    />
                                </Box>
                            </>
                        )}
                    </Box>
                    <Box
                        role="tabpanel"
                        id="item-settings-checklist"
                        aria-labelledby="tab-item-settings-checklist"
                    >
                        {!statusReplace &&
                            !isLookHistory &&
                            savedChecklistStepData &&
                            savedChecklistStepData.map((data, index) => (
                                <Grid
                                    key={index}
                                    container
                                    className="container-item-checklist"
                                >
                                    <Grid
                                        item
                                        xs={12}
                                        md={8}
                                        className="description-checklist"
                                    >
                                        <TypographyLevel
                                            variant="fifth"
                                            className="checklist-detail"
                                            id={`data-checklist[${index}]`}
                                        >
                                            {data.description}
                                        </TypographyLevel>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                        md={2}
                                        className="switch-green-checklist"
                                    >
                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            alignItems="center"
                                            textAlign="left"
                                        >
                                            <TypographyLevel
                                                variant="fifth"
                                                className="checklist-detail"
                                                id={`data-checklist[${index}]`}
                                            >
                                                Skip Green Check
                                            </TypographyLevel>
                                            <SwitchComp
                                                checked={data.hideStep}
                                                inputProps={{
                                                    'aria-labelledby': `data-checklist[${index}]`,
                                                }}
                                                data-stepId={data.actions.uuid}
                                                onChange={
                                                    actionToSwitchBetweenReviewStepActivation
                                                }
                                            />
                                        </Stack>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                        md={2}
                                        className="switch-checklist"
                                    >
                                        <Stack
                                            direction="row"
                                            spacing={2}
                                            alignItems="center"
                                            textAlign="left"
                                            paddingLeft={2}
                                        >
                                            <TypographyLevel
                                                variant="fifth"
                                                className="checklist-detail"
                                                id={`data-checklist[${index}]`}
                                            >
                                                Checklist Item
                                            </TypographyLevel>
                                            <SwitchComp
                                                checked={data.enabled}
                                                inputProps={{
                                                    'aria-labelledby': `data-checklist[${index}]`,
                                                }}
                                                data-stepId={data.actions.uuid}
                                                onChange={
                                                    actionToSwitchBetweenHandledChecklistStep
                                                }
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            ))}
                    </Box>
                    <Box
                        role="tabpanel"
                        id="item-checklist"
                        aria-labelledby="tab-item-checklist"
                    >
                        {!statusReplace &&
                            isLookHistory &&
                            checkListHistory &&
                            checkListHistory.map((data, index) => (
                                <Box
                                    key={index}
                                    className="container-item-checklist"
                                >
                                    <TypographyLevel
                                        variant="fifth"
                                        className="checklist-detail"
                                    >
                                        {data.placeHolder}
                                    </TypographyLevel>
                                </Box>
                            ))}
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default CheckListClientSettings;
